import FullScreenPlayer from 'components/molecules/FullScreenPlayer';
import { Col, Row } from 'react-bootstrap';
import { styled } from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  padding-right: 30px;
  scroll-behavior: smooth;
`;

export const StyledContainer = styled(Row).attrs(({ theme }) => ({
  className: theme.components.homeCarousel?.container.marginTopClassName ?? '',
}))`
  overflow-y: hidden;
  overflow-x: scroll;
  scroll-behavior: smooth;
`;

export const StyledTitle = styled.p`
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: -16px;
  margin-top: 24px;
  padding-right: 30px;
`;

// FAQCard styles
export const StyledImage = styled.img`
  width: ${({ theme }) => theme.components.homeCarousel?.faqCard.width ?? '140px'};
  height: ${({ theme }) => theme.components.homeCarousel?.faqCard.height ?? '160px'};
`;

export const StyledCol = styled(Col)`
  width: ${({ theme }) => theme.components.homeCarousel?.faqCard.width ?? '140px'};
  height: ${({ theme }) => theme.components.homeCarousel?.faqCard.height ?? '160px'};
  margin-right: ${({ theme }) => theme.components.homeCarousel?.faqCard.marginRight ?? '8px'};
`;

export const StyledFullScreenPlayer = styled(FullScreenPlayer).attrs(({ theme }) => ({
  thumbnailWidth: theme.components.homeCarousel?.faqCard.width ?? '140px',
  thumbnailHeight: theme.components.homeCarousel?.faqCard.height ?? '160px',
}))``;
